import { useEffect } from 'react';
import { useCookieConsent } from '../contexts/CookieConsentContext';

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-42MLDYDL6Q';

const loadGoogleAnalytics = () => {
  if (typeof window === 'undefined' || window.gtag || !GA_MEASUREMENT_ID) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);}
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    anonymize_ip: true
  });
};

export const useGoogleAnalytics = () => {
  const { consent } = useCookieConsent();

  useEffect(() => {
    if (consent.analytics) {
      loadGoogleAnalytics();
    }
  }, [consent.analytics]);
};

